/* eslint-disable no-unreachable */
import * as types from "./types";
import Vue from "vue";
import router from "@/router/index.js";

function toLegacyAdminLevel(claims = {}) {
  if (typeof claims.level === "number") return claims.level;

  switch (claims.role) {
    case "developer":
      return 0;
    case "admin":
      return 1;
    case "staff":
      return 2;
    default:
      return 3;
  }
}

function normalizeClaims(claims = {}) {
  if (!claims || typeof claims !== "object") {
    return claims;
  }

  return {
    ...claims,
    level: toLegacyAdminLevel(claims),
    disabled: Boolean(claims.disabled),
  };
}
// context === {dispatch: ƒ, commit: ƒ, getters: {…}, state: {…}, rootGetters: {…},…}
export default {
  async [types.SET_USER]({ commit, dispatch }, user) {
    await commit(types.SET_USER, user);
    if (!user) {
      commit(types.SET_FIREBASE_LOADED);
      return null;
    }
    try {
      await dispatch(user.VISIT_USER);
    } catch (e) {
      console.log(e.message);
    }
    await dispatch(types.SET_TOKEN);
    return true;
  },

  async [types.VISIT_USER]({ state }) {
    if (!state.user.displayName) return false;
    const increment = Vue.prototype.$firebase.firestore.FieldValue.increment(1);
    await Vue.prototype.$firebase
      .firestore()
      .collection("users")
      .doc(state.user.uid)
      .update({
        displayName: state.user.displayName,
        visitedAt: new Date(),
        visitCount: increment,
      });
    return true;
  },

  async [types.SET_TOKEN]({ commit, state }) {
    // const timer = await setInterval(async () => {
    // getIdToken으로 토큰 정보 가져옴 true 로 새 트큰 받아옴
    // const token = await state.data.user.getIdToken(true);
    // if (token) {
    //   commit(types.SET_TOKEN, token);
    //   const { claims } = await state.data.user.getIdTokenResult();
    //   await commit(types.SET_CLAIMS, claims);
    //   commit(types.SET_FIREBASE_LOADED);
    //   // clearInterval(timer);
    //   return true;
    // }
    // }, 500);
    const { token, claims } = await state.data.user.getIdTokenResult(true);
    commit(types.SET_TOKEN, token);
    commit(types.SET_CLAIMS, normalizeClaims(claims));
    commit(types.SET_FIREBASE_LOADED);
    return true;
  },

  async [types.SET_LOGOUT]({ commit, dispatch }, route) {
    dispatch(types.SET_USER, null);
    commit(types.SET_CLAIMS, null);
    commit(types.SET_TOKEN, null);
    await Vue.prototype.$firebase.auth().signOut();
    if (route && router.currentRoute.name != route) {
      router.push({ name: route });
    }
    return true;
  },
};
